import $ from 'jquery';
export default {
	init() {
		var distance = 0;
		$(window).scroll(function () {
			distance = $(window).scrollTop();
			//$('.artifacts-bg').css('bottom', -distance + '%');
			$('.artifact.a1').css('margin-bottom', distance / 2 + 'px');
			$('.artifact.a2').css('margin-bottom', distance / 4 + 'px');
			$('.artifact.a3').css('margin-bottom', distance / 3 + 'px');
			$('.artifact.a4').css('margin-bottom', distance / 2 + 'px');
			$('.artifact.a5').css('margin-bottom', distance / 2 + 'px');
			$('.artifact.a6').css('margin-bottom', distance / 2 + 'px');
			$('.artifact.a7').css('margin-bottom', distance / 2 + 'px');
			$('.artifact.a8').css('margin-bottom', distance / 2 + 'px');
		});
	},
	finalize() {},
};
